module.exports = __webpack_public_path__ + "media/images/signup-and-read-kv-2nd@2x-7364a21cc900b9c0d042cef110b3ffc6.png";